function n(n){return null==n?null:n.replace(/^0x/,"").replace(/^Fx/,"")}function l(l){return null==l?null:"0x"+n(l)}function u(n){return l(n)}export{u as display,n as sansPrefix,l as withPrefix};
//# sourceMappingURL=util-address.module.js.map
